import * as actions$2 from "./CCC/CCC/actions.js";
import * as actions$1 from "./data-layer/data-layer/actions.js";
import * as actions$3 from "./Prescriptions/state/Prescriptions/state/actions.js";
import * as actions from "./Profile/Profile/actions.js";
import * as actions$4 from "./Unlink/Unlink/actions.js";
const CHANGE_FORM_VALUE = "my-account/change-form-value";
const changeFormValue = (payload) => ({
  type: CHANGE_FORM_VALUE,
  payload
});
export {
  actions$2 as CCCActions,
  CHANGE_FORM_VALUE,
  actions$1 as DataLayerActions,
  actions$3 as PrescriptionsActions,
  actions as ProfileActions,
  actions$4 as UnlinkActions,
  changeFormValue
};
//# sourceMappingURL=actions.js.map
